<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M11 7L8 10L5 7"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M8 3L8 10"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
  />
  <path
    d="M14 13L8 13L2 13"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
  />
</svg>
